module.exports = __webpack_public_path__ + "img/11.f1468fa1.png";